import ReducerCreator from '../registerReducer';
import { buildStoreItem } from '../storeItemBuilder';
import * as HSC from './hsc.constants';
import { HistorianStorageConfiguration } from '../../models';
import { StoreItem, copy } from '../Store';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';

const r = new ReducerCreator<HistorianStorageConfiguration>()
    .register<HistorianStorageConfiguration[]>(HSC.HSCS_LOAD, (HSC, payload) => {
        const newHSC = new StoreItem<HistorianStorageConfiguration>();
        newHSC.isLoading = true;
        return newHSC;
    })
    .register<HistorianStorageConfiguration[]>(HSC.HSCS_LOAD_SUCCESS, (HSC, payload) => {
        return buildStoreItem(payload);
    })
    .register<string>(HSC.HSC_DELETE_SUCCESS, (HSC, payload) => {
        const newHSC = copy(HSC);
        const { dictionary } = newHSC;
        delete (dictionary[payload]);
        return newHSC;
    })
    .register<HistorianStorageConfiguration>(HSC.HSC_DELETE, (HSC, payload) => {
        const newHSC = copy(HSC);
        newHSC.isLoading = true;
        return newHSC;
    })
    .register<HistorianStorageConfiguration>(HSC.HSC_UPDATE, (HSC, payload) => {
        const newHSC = copy(HSC);
        newHSC.isLoading = true;
        return newHSC;
    })
    .register<HistorianStorageConfiguration>(HSC.HSC_UPDATE_SUCCESS, (HSC, payload) => {
        const newHSC = copy(HSC);
        const { dictionary } = newHSC;
        dictionary[payload.guid] = payload;
        newHSC.isLoaded = true;
        newHSC.isLoading = false;
        return newHSC;
    })
    .register<string>(APPLICATION_DISCONNECTED, (HSC, payload) => {
        const newHSC = new StoreItem<HistorianStorageConfiguration>();
        return newHSC;
    });

export function historianStorageConfigurationsReducer(HSC: StoreItem<HistorianStorageConfiguration> = new StoreItem<HistorianStorageConfiguration>(), action: { type: string, payload: any }) {
    return r.reduce(HSC, action);
}
